// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Note__Wrapper_2TQ-r"};